<template>
  <div class="analytics">
    <h2>Аналитика</h2>
    <el-row>
      <el-col>
        <div class="analytics__switcher">
          <Switcher v-model="activeSwitch" :data="tabs" />
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" type="flex" class="flex-wrap">
      <template v-if="activeSwitch">
        <el-col class="mb-16" :md="24" :lg="12">
          <el-card class="w-height">
            <div class="analytics__card">
              <el-select v-model="usersSelect" class="analytics__select">
                <el-option v-for="item in selectOptions" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
              <table class="common__table" cellspacing="0">
                <thead>
                  <tr>
                    <td>Данные</td>
                    <td>Показатель</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tr, index) in tableData" :key="index" @click="getChartData(index)">
                    <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                      {{ tr.item }}
                    </td>
                    <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                      {{ tr.value }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-card>
        </el-col>
        <el-col class="mb-16" :md="24" :lg="12">
          <el-card class="w-height">
            <div class="analytics__card">
              <p class="analytics__title">Освоение модулей</p>
              <el-card class="analytics__card--mb module">
                <div class="analytics__card">
                  <div class="analytics__progress">
                    <div class="analytics__progress-max">
                      <span>Модуль 2 (max)</span>
                      <Progress type="success" :percentage="70" />
                    </div>
                    <div class="analytics__progress-description">
                      110 <span>пользователей</span>
                    </div>
                  </div>
                  <div class="analytics__progress">
                    <div class="analytics__progress-min">
                      <span>Модуль 1 (min)</span>
                      <Progress type="exception" :percentage="10" />
                    </div>
                    <div class="analytics__progress-description">4 <span>пользователя</span></div>
                  </div>
                </div>
              </el-card>
              <p class="analytics__card-users">Пользователи</p>
              <Chart :chartOptions="chartOptions" :series="[...formatExtraData]" chartType="bar" />
            </div>
          </el-card>
        </el-col>
      </template>
      <template v-if="!activeSwitch">
        <el-col class="mb-16" :md="24" :lg="12">
          <el-card class="w-height">
            <div class="analytics__card">
              <el-select v-model="usersSelect" class="analytics__select">
                <el-option v-for="item in selectOptions" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
              <table class="common__table" cellspacing="0">
                <thead>
                  <tr>
                    <td>Данные</td>
                    <td>Показатель</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tr, index) in tasks" :key="index" @click="getChartData(index)">
                    <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                      {{ tr.item }}
                    </td>
                    <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                      {{ tr.value }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-card>
        </el-col>
        <el-col class="mb-16" :md="24" :lg="12">
          <el-card class="w-height">
            <div class="analytics__card">
              <p class="analytics__title">Среднее время, затраченное на выполнение заданий</p>
              <el-card class="analytics__card--mb module">
                <div class="analytics__card">
                  <div class="analytics__progress">
                    <div class="analytics__progress-max">
                      <span>Модуль 2 (max)</span>
                      <Progress type="success" :percentage="70" />
                    </div>
                    <div class="analytics__progress-description">
                      110 <span>пользователей</span>
                    </div>
                  </div>
                  <div class="analytics__progress">
                    <div class="analytics__progress-min">
                      <span>Модуль 1 (min)</span>
                      <Progress type="exception" :percentage="10" />
                    </div>
                    <div class="analytics__progress-description">4 <span>пользователя</span></div>
                  </div>
                </div>
              </el-card>
              <p class="analytics__card-users">Пользователи</p>
              <Chart :chartOptions="chartOptions" :series="[...formatTasksData]" chartType="bar" />
            </div>
          </el-card>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Analytics',
  components: {
    Progress: () => import(/* WebpackChunkName: "Progress" */ '@/components/Common/Progress.vue'),
    Chart: () => import(/* WebpackChunkName: "Chart" */ '@/components/Common/Chart.vue'),
    Switcher: () => import(/* WebpackChunkName: "Switcher" */ '@/components/Common/Switcher.vue')
  },

  data: () => ({
    usersSelect: '',
    selectOptions: ['По имени А-Я'],
    tableData: [
      { item: 'Среднее время, потраченное на одно задание', value: '2 минуты' },
      { item: 'Среднее время, потраченное на прохождение одного дня', value: '40 минут/сутки' },
      { item: 'Среднее время, проведённое на платформе', value: '60 минут/сутки' },
      { item: 'Среднее количество уникальных активных пользователей', value: '450 человек/сутки' },
      { item: 'Модуль, который осваивает наибольшее число пользователей', value: 'Модуль 2' }
    ],
    chartOptions: {
      chart: {
        height: 350,
        type: 'bar'
      },
      colors: ['#EE2A24', '#00A94F', '#F2994A', '#EE2A24'],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      tooltip: {
        fixed: {
          enabled: false,
          position: 'topRight'
        },
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const currentColor = w.config.colors[dataPointIndex]
          const bar = document.querySelector('.apexcharts-tooltip')
          if (!bar) {
            return
          }
          bar.style.setProperty('--bar-color', currentColor)

          return `
            <div class="arrow_tooltip">
              <span>
                ${series[seriesIndex][dataPointIndex]}
              </span>
            </div>
           `
        }
      }
    },
    chartData: [
      { date: 'Модуль 1', visits: 10 },
      { date: 'Модуль 2', visits: 120 },
      { date: 'Модуль 3', visits: 80 },
      { date: 'Модуль 4', visits: 20 }
    ],
    activeIndex: 0,
    tabs: [
      { label: 'Пользователи', value: true },
      { label: 'Задания', value: false }
    ],
    activeSwitch: true,
    tasks: [
      { item: 'Среднее время выполнения одного задания', value: 'Задание 1. 5 минут' },
      {
        item: 'Задание, которое выполняется дольше всего',
        value: 'Задание 2. Урок 4. Раздел 5. Модуль 1'
      },
      {
        item: 'Больше всего допускается ошибок в задании',
        value: 'Задание 5. Урок 3. Раздел 1. Модуль 2'
      }
    ],
    tasksChartData: [
      { date: 'Задание 1', visits: 5 },
      { date: 'Задание 2', visits: 80 },
      { date: 'Задание 3', visits: 60 },
      { date: 'Задание 4', visits: 20 },
      { date: 'Задание 5', visits: 14 }
    ]
  }),
  computed: {
    formatExtraData() {
      return {
        name: 'Модуль',
        data: this.chartData.map(item => {
          return {
            x: item.date,
            y: item.visits
          }
        })
      }
    },
    formatTasksData() {
      return {
        name: 'Задание',
        data: this.tasksChartData.map(item => {
          return {
            x: item.date,
            y: item.visits
          }
        })
      }
    }
  },
  // Todo: отрефакторить на дату с бэка. временно для наглядности
  methods: {
    getChartData(index) {
      this.activeIndex = index
      this.chartData = [
        { date: 'Модуль 1', visits: Math.floor(Math.random() * 500) },
        { date: 'Модуль 2', visits: Math.floor(Math.random() * 400) },
        { date: 'Модуль 3', visits: Math.floor(Math.random() * 300) },
        { date: 'Модуль 4', visits: Math.floor(Math.random() * 200) }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.analytics {
  h2 {
    margin-bottom: 50px;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: #0079c1;
  }

  &__select {
    margin-bottom: 20px;
  }

  &__title {
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: #202032;
  }

  &__progress {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 10px;

    &-description {
      display: inline-flex;
      flex-basis: 150px;
      margin-left: 10px;
      white-space: nowrap;
      font-size: 13px;
      letter-spacing: -0.08px;
      color: $deepdark;

      span {
        margin-left: 10px;
        font-size: 13px;
        letter-spacing: -0.08px;
        color: #b6b9c3;
        white-space: nowrap;
      }
    }
  }

  &__progress-max,
  &__progress-min {
    flex-basis: 74%;
    font-size: 13px;
    letter-spacing: -0.08px;
    color: $deepdark;

    span {
      display: inline-block;
      margin-bottom: 4px;
    }

    @include sm-and-down {
      flex-basis: 60%;
    }
  }

  &__card {
    width: 100%;
    overflow-y: hidden;

    &-users {
      font-size: 12px;
      color: #b6b9c3;
    }

    &--mb {
      margin-bottom: 24px;
    }
  }

  &__switcher {
    max-width: 250px;
    padding-left: 10px;
    margin-bottom: 24px;
  }
}

.module {
  max-width: 50%;

  @include sm-and-down {
    max-width: 100%;
  }

  @include lg-only {
    max-width: 100%;
  }
}

::v-deep .el-input__inner {
  border-radius: 20px;
  padding-left: 14px;
  min-width: 240px;
}

::v-deep #chart .apexcharts-tooltip {
  --bar-color: #f2994a;
  padding: 4px 16px;
  border-radius: 10px;
  color: $white;
  box-shadow: 0 0 11px rgba(0, 0, 0, 0.12);
  transform: translateX(-50%) translateY(-100%);
  overflow: visible !important;

  span {
    position: relative;
    font-weight: bold;
    font-size: 24px;
    color: var(--bar-color, #f2994a);
  }

  &:before {
    right: 34%;
    top: 68%;
    border: 10px solid transparent;
    border-top: 10px solid #fff;
    content: ' ';
    height: 24px;
    width: 10px;
    position: absolute;
    pointer-events: none;
    transform: translateY(50%);
    filter: drop-shadow(0 4px 3px #b6b9c3ab);
  }
}

::v-deep .apexcharts-inner > defs:first-of-type > clipPath:first-of-type {
  clip-path: inset(0% 0% 0% 0% round 10px 10px 0 0);
}
</style>
